import { Address } from "wagmi";

export const formatAddress = (address: Address) => {
  return address.slice(0, 6) + "..." + address.slice(address.length - 4, address.length);
};

export const formatTxHash = formatAddress;
